import * as React from "react";
import ContextWrapper from "./src/contexts/ContextWrapper";
import { NotificationContainer } from "./src/components";
import { syncForcedDateFromUrl } from "./src/utils/forcedate";

import "./static/css/base.css";
import "./static/css/theme.css";
import "./static/css/global.scss";
import "./static/vendor/leaflet/leaflet.css";

// Leaflet.heat expects Leaflet as a browser global. Loading both libraries from the
// browser entry keeps their initialization deterministic across Gatsby page changes.
if (typeof window !== "undefined") {
  window.L = require("./src/vendor/leaflet/leaflet.js");
  require("./src/vendor/leaflet/leaflet-heat.js");
}

export const wrapRootElement = ({ element }) => {
  return <ContextWrapper>{element}</ContextWrapper>;
};

// UI belongs here, not in wrapRootElement: wrapPageElement wraps only the page, while
// wrapRootElement also wraps Gatsby's Head render, which is how a <div> ended up in <head>.
// It still sits inside the providers, since wrapPageElement renders within wrapRootElement.
export const wrapPageElement = ({ element }) => {
  return (
    <>
      {element}
      <NotificationContainer />
    </>
  );
};

// Capture ?FORCE_DATE on every route, including pages with no date-gated logic of their own.
// Without this the override is only stored when something happens to call getNow().
export const onRouteUpdate = () => {
  syncForcedDateFromUrl();
};

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  if (!prevRouterProps || !routerProps) {
    return;
  }
  const { location: prevLocation } = prevRouterProps;
  const { location: nextLocation } = routerProps;
  const { pathname: prevPathname } = prevLocation;
  const { pathname: nextPathname } = nextLocation;

  const prevPathSegments = prevPathname.slice(1).split("/").slice(0, 2);
  const nexPathSegments = nextPathname.slice(1).split("/").slice(0, 2);

  if (prevPathSegments.toString() === nexPathSegments.toString()) {
    return false;
  }
  return true;
};
